<div class="email-verification-page-container container">
  <p>{{ 'EMAIL_VERIFICATION.SUCCESS_MESSAGE' | translate }}</p>
</div>
